import styled from "styled-components";

export const Section = styled.div`
  background: #111522;
  border: 1px solid #1f2937;
  border-radius: 18px;
  padding: 22px;
  margin-bottom: 26px;
  transition: box-shadow 0.3s ease;
  &:hover {
    box-shadow: 0 0 18px rgba(0, 247, 210, 0.25);
  }

  @media (max-width: 768px) {
    padding: 16px;
    margin-bottom: 20px;
    border-radius: 12px;
  }

  @media (max-width: 480px) {
    padding: 12px;
    margin-bottom: 16px;
    border-radius: 10px;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  margin-bottom: 14px;
  background: linear-gradient(90deg, #00f7d2, #5ce9ff);
  -webkit-background-clip: text;
  color: transparent;

  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 12px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
    margin-bottom: 10px;
  }
`;

export const Page = styled.div`
  padding: 32px;
  background: #0b0e14;
  color: #e5e7eb;
  min-height: 100vh;
  overflow-x: hidden;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "SF Pro Text",
    "Segoe UI", sans-serif;

  @media (max-width: 768px) {
    padding: 16px;
  }

  @media (max-width: 480px) {
    padding: 12px;
  }
`;

export const MiniChartBar = styled.div`
  height: 8px;
  border-radius: 999px;
  background: linear-gradient(90deg, #00f7d2, #5ce9ff);
  transition: width 0.25s ease-out;
`;

